export default [
    {
        link: "https://amzn.to/4ls1PlV",
        image: "/images/monster-pack.png",
        caption: "ZERO SUGAR Monster",
        name: "ZERO SUGAR Monster",
        description: "Monster Energy Zero Sugar, Green, Original, Low Calorie Energy Drink, 16 ounce (Pack of 15)",
        jaseNotes: "One of my favorite beverages is Monster, specifically the ZERO SUGAR Monster. Click the image below to view on Amazon.",
    },
    {
        link: "https://amzn.to/3UsyBsl",
        image: "/images/equipment/sony-a6000-camera.jpg",
        caption: "Sony Alpha a6000 Mirrorless Digital",
        name: "Sony Alpha a6000 Mirrorless Digital",
        description: "Sony Alpha a6000 Mirrorless Digital Camera 24.3MP SLR Camera with 3.0-Inch LCD (Black) w/16-50mm Power Zoom Lens",
        jaseNotes: "My wife used this camera for photos but I repurposed it for my videos and streams.  I connect it to my computer using an Elgato Cam Link.",
    },
    {
        link: "https://amzn.to/4mKOeHp",
        image: "/images/equipment/elgato-cam-link.jpg",
        caption: "Elgato Cam Link 4K",
        name: "Elgato Cam Link 4K: Camera Capture Card",
        description: "Elgato Cam Link 4K, External Camera Capture Card, Stream and Record with DSLR, Camcorder, ActionCam as Webcam in 1080p60, 4K30 for Video Conferencing, Home Office, Gaming, on OBS, Zoom, Teams, PC/Mac",
        jaseNotes: "This let's me connect the Sony a6000 to my computer as a webcam.  I use it for my live streams and videos.",
    },
    {
        link: "https://amzn.to/3JjYQia",
        image: "/images/equipment/blue-yeti-microphone-and-stand.jpg",
        caption: "Blue Yeti Pro Microphone and Stand",
        name: "Blue Yeti Pro Microphone and Stand",
        description: "The Blue Yeti is a great microphone for streaming, podcasting, and voiceovers. It has a built-in stand and is plug-and-play with USB.",
        jaseNotes: "This USB microphone is what I use on my videos and live streams.  I have it hang above me on the boom arm.",
    },
    {
        link: "https://amzn.to/4mIHBp0",
        image: "/images/equipment/g910-keyboard.jpg",
        caption: "Logitech G910 Keyboard",
        name: "Logitech G910 Orion Spectrum RGB Wired Mechanical Gaming Keyboard",
        description: `Romer-G Mechanical Key Switches: Features exclusive Romer-G mechanical key switches with 1.5mm actuation for 25% faster input response and 40% greater durability (70 million keystrokes) compared to leading competitors.
        RGB Illumination and G-Keys: Offers customizable RGB illumination across 16 million colors for each key. Includes 9 programmable G-keys positioned for optimal accessibility.
        Dedicated Media Controls: Integrated media control keys and roller bar for adjusting volume, playing/pausing media, and skipping scenes.`,
        jaseNotes: "A keyboard that let's me see pretty RGB colors and program some extra keys.",
    }
]